import { render, staticRenderFns } from "./BudgetManage.vue?vue&type=template&id=092bd166&scoped=true"
import script from "./BudgetManage.vue?vue&type=script&lang=js"
export * from "./BudgetManage.vue?vue&type=script&lang=js"
import style0 from "./BudgetManage.vue?vue&type=style&index=0&id=092bd166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092bd166",
  null
  
)

export default component.exports